import React from 'react'
import style from './index.module.less'
import { LearnBuyBtn2 } from "@/new_components"
import xrealLogo from "@/images/xreal_logo.svg"
import { useIntl } from "react-intl"

const Supports = ({ supportsList }) => {
  const intl = useIntl()
  return (
    <div className={style.supports}>
      {supportsList.map((sItem) => (
          <div className={style.supportItem} key={`support${sItem.title}-${sItem.desc}`}>
            <div>
              <img
                src={sItem.img || xrealLogo}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = xrealLogo;
                }}
                width={96}
                height={96}
              />
            </div>
            <div className={style.title}>{intl.formatMessage({ id: sItem.title })}</div>
            {sItem.desc &&<div className={style.desc}>{intl.formatMessage({ id: sItem.desc })}</div>}
            <div className={style.btn}>
              <LearnBuyBtn2 link={sItem.learn_link} link_out={sItem.learn_out} btnText={sItem.btnLearn} />
            </div>
          </div>
        )
      )}
    </div>
  )
}

export default Supports
